import { Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AsyncPipe } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { DownloadInformationDialog } from "../../shared/dialogs/download-information-dialog";
import { DownloadRequestDialog } from "../../shared/dialogs/download-request-dialog";
import { Router, NavigationEnd, RouterLink } from "@angular/router";
import { PleaseRegisterDialog } from "../../shared/dialogs/please-register-dialog";
import { LogoutDialog } from "../../shared/dialogs/logout-dialog";
import { UserStore } from '../../core/stores/user.store';
import { map, filter } from 'rxjs/operators';
import { SpinComponent } from "./spin/spin.component";
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    // Prerendered pages show the logged-out header; the browser re-renders it for the actual user.
    host: { ngSkipHydration: 'true' },
    imports: [AsyncPipe, RouterLink, SpinComponent, MatButton, MatIcon, MatMenu, MatMenuItem, MatMenuTrigger, MatTooltip]
})
export class HeaderComponent {
  private readonly dialog = inject(MatDialog);
  private readonly userStore = inject(UserStore);

  public user$ = this.userStore.currentUser$;

  public userName$ = this.user$.pipe(
    filter(user => user !== null),
    map(user => user.email)
  );

  public credits$ = this.user$.pipe(
    filter(user => user !== null),
    map(user => user.credits)
  );

  public authenticated$ = this.user$.pipe(
    map(user => user !== null),
  );

  // The map: "/" or "/x/y/z". Not a permanent fix, but works until the viewer is greatly expanded.
  public readonly kaartViewActive = toSignal(
    inject(Router).events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => event.url === "/" || event.url.split("/").length === 4)
    ),
    { initialValue: true }
  );

  public openDownloadDialog() {
    if (!this.userStore.isLoggedIn()) {
      this.dialog.open(PleaseRegisterDialog, {
        width: "500px",
        panelClass: "bgt-dialog",
        autoFocus: false
      });
      return;
    }

    if (this.userStore.hasEnoughCredits()) {
      this.dialog.open(DownloadRequestDialog, {
        width: "500px",
        panelClass: "bgt-dialog",
        autoFocus: false
      });
    } else {
      this.dialog.open(DownloadInformationDialog, {
        width: "500px",
        panelClass: "bgt-dialog",
        autoFocus: false
      });
    }
  }

  public openLogoutDialog() {
    const dialogRef = this.dialog.open(LogoutDialog, {
      width: "350px",
      height: "165px",
      panelClass: "bgt-dialog",
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(iWantToLogout => {
      if (iWantToLogout) {
        this.userStore.clearCurrentUser();
      }
    });
  }
}
